export class VoucherServiceError extends Error {
    constructor(...params: any) {
        super(...params);
        if (params[0] && typeof params[0] === 'string') {
            // eslint-disable-next-line prefer-destructuring
            this.message = params[0];
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, VoucherServiceError);
        }

        this.name = 'VoucherServiceError';
    }

    static fromMissingProperty(property:string): VoucherServiceError {
        return new VoucherServiceError(`Property ${property} is missing in the data`);
    }

    static fromMissingRequestProperty(property: string, request: string): VoucherServiceError {
        return new VoucherServiceError(`Property ${property} must exists in the payload when using ${request}`);
    }

    static fromMissingSupplier(): VoucherServiceError {
        return new VoucherServiceError('Supplier service was not able to return an identifier for this supplier during initialisation');
    }
}

export default VoucherServiceError;
